var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controlItem form-group",class:_vm.control.className},[_c(_vm.controlInstance,{tag:"component",attrs:{"control":_vm.control,"label-position":_vm.labelPosition,"readonly":_vm.readonly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }